<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field id="prompt-name" v-model="node.name" label="Name" dense>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field
          v-model="property.intent_variable"
          label="Intent variable"
          hint="For example, ${input.intent}"
          dense
          @keyup.down="pressDown"
          @keyup.up="pressUp"
          @keydown.enter="onEnter"
          @keydown.tab="pressTab"
        >
        </v-text-field>
        <!-- === use for Intellisense ===-->
        <intellisense-component
          :input="property.intent_variable"
          :drawFlowItems="drawFlowItems"
          :property="'intent_variable'"
          :apiForIntellisense="apiForIntellisense"
          :start="start"
          @clearSelected="clearSelected"
          :eventKey="eventKey"
          @updateInputFromIntellisense="updateInputFromIntellisense"
        />
        <!-- === use for Intellisense ===-->
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="d-flex p-b-0">
        <div class="input-title">Intent mapping</div>
      </v-col>
    </v-row>
    <div class="p-l-15">
      <div v-for="(mapping, index) in property.mapping" :key="index">
        <div class="d-flex align-start m-t-15">
          <fieldset class="form-group m-b-0 width100 height200px">
            <v-row>
              <v-col cols="12" sm="12" lg="12">
                <v-autocomplete
                  class="add-intent m-auto"
                  :items="intentFilter"
                  item-text="name"
                  item-value="_id"
                  label="Click to add intent"
                  append-icon=""
                  dense
                  hide-details
                  @change="addIntentInMapping($event, index)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0 p-b-0">
                <v-chip
                  v-for="(obj, index2) in property.mapping[index].intents"
                  class="ma-1"
                  outlined
                  :key="index2"
                >
                  <div :id="`item${index2}`">{{ findIntentName(obj) }}</div>
                  <v-icon
                    class="ml-2 m-r-0"
                    x-small
                    right
                    @click="deleteIntentInMapping(obj, index, index2)"
                  >
                    fa-times
                  </v-icon>
                </v-chip>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" lg="12" class="d-flex">
                <v-select
                  class="m-auto"
                  v-model="property.mapping[index].page"
                  :items="tabFilter"
                  item-text="name"
                  item-value="id"
                  label="Page"
                  dense
                  hide-details
                ></v-select>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      class="m-l-10"
                      :disabled="!property.mapping[index].page"
                      @click="goToPage(property.mapping[index].page)"
                    >
                      fa-arrow-up-right-from-square
                    </v-icon>
                  </template>
                  <span>Open page</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </fieldset>
          <v-icon small class="m-l-10" @click="deleteMapping(index)"
            >fa-times-circle</v-icon
          >
        </div>
      </div>

      <div class="d-inline-flex m-t-15" @click="addMapping()">
        <v-icon class="cursor-pointer m-r-5" small>fa-plus-circle</v-icon>
        <div class="cursor-pointer">
          Add intent mapping
        </div>
      </div>
    </div>

    <hr class="note-divider" />
    <note-component :node="node" />
  </div>
</template>

<script>
import _ from 'lodash'
import apiIntent from '@/apis/intent'

import NoteComponent from '../../../components/note'
// === use for Intellisense ===
import IntellisenseComponent from '../../../components/intellisense'
// === use for Intellisense ===
export default {
  props: {
    node: Object,
    tabs: Array,
    // === use for Intellisense ===
    drawFlowItems: Object,
    apiForIntellisense: Object
    // === use for Intellisense ===
  },
  components: {
    NoteComponent,
    // === use for Intellisense ===
    IntellisenseComponent
    // === use for Intellisense ===
  },
  data() {
    return {
      property: {},
      intents: [],
      intentFilter: [],
      currentIndex: 0,
      // === use for Intellisense ===
      start: -1,
      isKeyTab: false,
      eventKey: ''
      // === use for Intellisense ===
    }
  },
  watch: {
    intents: {
      deep: true,
      handler() {
        this.intentFilter = _.filter(this.intents, { is_show: true })
      }
    }
  },
  async created() {
    this.property = this.node.property
    const tabFilter = _.filter(this.tabs, o => o.name !== 'Home')
    this.tabFilter = _.sortBy(tabFilter, [
      function(o) {
        return o.name.toLowerCase()
      }
    ])

    await this.getIntent()

    // filter intents
    for (const obj of this.property.mapping) {
      for (const intent of obj.intents) {
        const objIndex = _.findIndex(this.intents, { _id: intent })
        if (objIndex > -1) {
          this.intents[objIndex].is_show = false
        }
      }
    }
  },
  methods: {
    async getIntent() {
      const getIntent = await apiIntent.getIntent()

      const { data } = getIntent

      this.intents = []
      for (const obj of data) {
        this.intents.push({
          _id: obj._id,
          name: obj.name,
          is_show: true
        })
      }
    },
    filterIntents(item, queryText, itemText) {
      if (item.is_show) return item
    },
    addMapping() {
      this.property.mapping.push({
        page: '',
        intents: [],
        intents_name: []
      })
    },
    deleteMapping(index) {
      this.property.mapping.splice(index, 1)
    },
    addIntentInMapping(intentId, index) {
      const intent = _.find(this.intents, { _id: intentId })
      if (intent) {
        this.property.mapping[index].intents.push(intent._id)
        this.property.mapping[index].intents_name.push(intent.name)

        const objIndex = _.findIndex(this.intents, { _id: intentId })
        if (objIndex > -1) {
          this.intents[objIndex].is_show = false
        }
      }
    },
    deleteIntentInMapping(intentId, indexMapping, indexIntentInMapping) {
      this.property.mapping[indexMapping].intents.splice(
        indexIntentInMapping,
        1
      )
      this.property.mapping[indexMapping].intents_name.splice(
        indexIntentInMapping,
        1
      )

      const objIndex = _.findIndex(this.intents, { _id: intentId })
      if (objIndex > -1) {
        this.intents[objIndex].is_show = true
      }
    },
    findIntentName(intent) {
      const find = _.find(this.intents, { _id: intent })
      return find ? find.name : ''
    },
    goToPage(pageId) {
      this.$emit('goToPage', pageId)
    },
    // === use for Intellisense ===
    pressDown() {
      this.start += 1
      this.eventKey = 'keydown'
    },
    pressUp() {
      this.start -= 1
      this.eventKey = 'keyup'
    },
    pressTab() {
      this.isKeyTab = true
      this.start = -1
    },
    onEnter() {
      this.start = -1
      this.eventKey = 'enter'
    },
    clearSelected() {
      this.start = -1
    },
    updateInputFromIntellisense(property, data) {
      this.property.intent_variable = data
    }
    // === use for Intellisense ===
  }
}
</script>

<style scoped lang="scss">
.no-margin-top {
  margin-top: 0px !important;
}
.body-dialog {
  margin: 10px !important;
}

::v-deep .add-intent .v-input__slot {
  &::before {
    border: none !important;
  }
}
</style>
